/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/ainvoice_medium'
export default icon
